import { TableCell, TableRow, Text } from "@jsq/ds/core";
import { Colors } from "@jsq/ds/styles";
import { tableCellStyle } from "./styles_vanilla.css";

interface TableDetailRowProps {
  label: string | React.ReactNode;
  value: string | React.ReactNode | null | undefined;
  dataTestId?: string;
}

export const TableDetailRow = ({ label, value, dataTestId }: TableDetailRowProps) => (
  <TableRow>
    <TableCell className={tableCellStyle}>
      <Text color={Colors.Neutral700} variant="secondary-md">
        {label}
      </Text>
    </TableCell>
    <TableCell className={tableCellStyle} data-testid={dataTestId}>
      <Text variant="regular-md">{value ?? "--"}</Text>
    </TableCell>
  </TableRow>
);
